// Waveform tuning. Lengths are in viewBox units (WIDTH x HEIGHT), frequencies in Hz
const aiAssistantWaveformConfig = {
    WIDTH: 168,
    // Fits the loudest wave (~17 units each side) plus its bloom (3 * BLOOM) - the SVG clips anything outside
    HEIGHT: 52,
    CENTER_Y: 26,
    // The CSS mask fades the ends out, so they can run almost to the edge
    MARGIN_X: 2,
    SAMPLES: 48,

    // Additive: white where strands overlap, colour fringe where they separate. `lag` = position across the
    // ribbon (0 centre, ±1 edge), `width` = half-thickness as a share of the ribbon's
    STRANDS: [
        {color: '#E8641E', lag: -1, width: 0.8},
        {color: '#8FB83A', lag: -0.4, width: 0.7},
        {color: '#2E9BEA', lag: 0.4, width: 0.8},
        {color: '#325ADC', lag: 1, width: 0.7},
        {color: '#FFFFFF', lag: 0, width: 0.4},
    ],

    // Cycle hump → S → bowl; the wobble keeps it from looking periodic
    ROLL_HZ: 0.11,
    ROLL_WOBBLE: 0.9,
    ROLL_WOBBLE_HZ: 0.047,

    // Peak offset from the centre line, "breathing" on two sines with unrelated periods
    SWAY: 5.2,
    SWAY_WAVES: [
        {weight: 0.2, frequencyHz: 0.13, phase: 0.4},
        {weight: 0.12, frequencyHz: 0.071, phase: 1.9},
    ],

    // Outer strand offset, in ribbon half-thicknesses. FAN + LEVEL_FAN_GAIN must stay below ~2.5
    // (neighbours' width sum / lag gap), or a dark gap opens between strands
    FAN: 0.45,
    // Speed of the twist where the strands cross and swap sides
    TWIST_HZ: 0.07,

    // MIN_HALF_THICKNESS ≈ 0.75 CSS px; thinner gets anti-aliased into flickering dots
    HALF_THICKNESS: 2.6,
    MIN_HALF_THICKNESS: 0.45,
    TAPER: 2.6,

    // Edge blur, glow blur, glow strength
    SOFTEN: 0.55,
    BLOOM: 2.8,
    BLOOM_GAIN: 1.4,

    // Added at full level. Raising sway, fan or thickness may need a bigger HEIGHT
    LEVEL_SWAY_GAIN: 0.45,
    LEVEL_FAN_GAIN: 0.85,
    LEVEL_THICKNESS_GAIN: 0.35,
    LEVEL_PACE_GAIN: 2.5,
};

export default aiAssistantWaveformConfig;
